export default "__VITE_ASSET__DXHCbmjL__"